import RewardCardDrawer from "./reward-card-drawer";
import NiceModal from "@ebay/nice-modal-react";

export const showRewardCardDrawer = () => {
  return NiceModal.show(RewardCardDrawer);
};

export const hideRewardCardDrawer = () => {
  return NiceModal.hide(RewardCardDrawer);
};
